import { Pipe, PipeTransform } from '@angular/core';

import { TransactionSolution } from '@shared/models';
import { getSolutionDisplayName } from '@shared/utils';

@Pipe({
  name: 'solutionName',
  standalone: true,
})
export class SolutionNamePipe implements PipeTransform {
  transform(value?: TransactionSolution): string {
    return getSolutionDisplayName(value);
  }
}
